import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Marker, InfoWindow } from '@react-google-maps/api';
import { markerIcons } from '../../app/google_maps';

function onDragEnd({ latLng }) {
  $('#depot_lat').val(latLng.lat());
  $('#depot_lng').val(latLng.lng());
  $('#depot_coordinates').val(`${latLng.lat()}, ${latLng.lng()}`);

  const $form = $('#depot_lat').parents('form');
  if ($form.data('auto-submit')) { $form.submit(); }
}

export default class DepotMarker extends Component {
  constructor(props) {
    super(props);
    this.state = { hover: false };
    this.onMouseOver = this.onMouseOver.bind(this);
    this.onMouseOut = this.onMouseOut.bind(this);
  }

  componentWillReceiveProps(newProps) {
    if (!newProps.selected) { return this.unsubscribeUIEvents(); }
    return this.subscribeUIEvents();
  }

  componentWillUnmount() {
    this.unsubscribeUIEvents();
  }

  onMouseOver() {
    this.setState({ hover: true });
  }

  onMouseOut() {
    this.setState({ hover: false });
  }

  unsubscribeUIEvents() {
    $('#depot_radius').off(this.eventName('change'));
  }

  subscribeUIEvents() {
    $('#depot_radius').off(this.eventName('change')).on(this.eventName('change'), ({ currentTarget }) => {
      const $form = $(currentTarget).parents('form');
      if ($form.data('auto-submit')) { $form.submit(); }
    });
  }

  eventName(event) {
    return `${event}.depot${this.props.depot.id}`;
  }

  render() {
    const { depot, selected, onClick } = this.props;
    let infoWindow;
    if (this.state.hover) {
      infoWindow = (
        <InfoWindow onCloseClick={this.onMouseOut}>
          <div className="info-depot-name">{depot.name}</div>
        </InfoWindow>
      );
    }
    return (
      <div>
        <Marker
          key={depot.id}
          position={{ lat: depot.lat, lng: depot.lng }}
          icon={markerIcons.depot}
          clickable
          draggable={selected}
          onMouseOver={this.onMouseOver}
          onMouseOut={this.onMouseOut}
          onClick={() => { onClick(depot); }}
          onDragEnd={onDragEnd}
        >
          {infoWindow}
        </Marker>
      </div>);
  }
}

DepotMarker.propTypes = {
  depot: PropTypes.shape({
    id: PropTypes.number,
    lat: PropTypes.number.isRequired,
    lng: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
  selected: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};
